export { createPageContextShared };
export { createPageContextObject };
import { execHookGlobal } from './hooks/execHook.js';
import { preparePageContextForPublicUsage } from './preparePageContextForPublicUsage.js';
import { changeEnumerable, objectAssign } from './utils.js';
async function createPageContextShared(pageContextCreated, pageConfigGlobal, vikeConfigPublicGlobal) {
    objectAssign(pageContextCreated, vikeConfigPublicGlobal);
    await execHookGlobal('onCreatePageContext', pageConfigGlobal, pageContextCreated, pageContextCreated, preparePageContextForPublicUsage);
    return pageContextCreated;
}
function createPageContextObject() {
    const pageContext = {
        _isOriginalObject: true,
        isPageContext: true,
    };
    changeEnumerable(pageContext, '_isOriginalObject', false);
    return pageContext;
}
